import { AnimatedIconName } from 'components/AnimatedIcon/AnimatedIconName';
import { Button } from 'components/Button/Button';
import { Tooltip } from 'components/Tooltip/Tooltip';
import { cmsApiCreateReaction } from 'modules/cms/api/cmsApiReactionEndpoints';
import { CmsApiReactionType } from 'modules/cms/api/types/CmsApiReactionType';
import { REACTIONS } from 'modules/cms/constants/reactions';

import { CmsReactionButtonContainer } from './CmsReactionButton.styled';
import { CmsReactionButtonTooltip } from './CmsReactionButtonTooltip';

type Props = {
  contentId: string;
  reactionType?: CmsApiReactionType;
  setReactionType: (reactionType: CmsApiReactionType) => void;
};

export function CmsReactionButton({
  contentId,
  reactionType,
  setReactionType,
}: Props) {
  const handleClickReaction = (clickedReactionType: CmsApiReactionType) =>
    cmsApiCreateReaction(contentId, clickedReactionType).then(() => {
      setReactionType(clickedReactionType);
    });

  return (
    <Tooltip
      content={
        <CmsReactionButtonTooltip onClickReactionButton={handleClickReaction} />
      }
      size="small"
      variant="filled"
      placement="top-center"
      animate
    >
      <CmsReactionButtonContainer
        data-qa-id="cms-reaction-button"
        data-qa-reaction-status={reactionType}
      >
        <Button
          fullWidth
          variant={
            reactionType ? REACTIONS[reactionType].buttonVariant : 'secondary'
          }
          icon={
            reactionType
              ? {
                  type: 'animated',
                  name: reactionType.toLowerCase() as AnimatedIconName,
                  options: { maxLoopCount: 2 },
                }
              : {
                  type: 'normalized',
                  name: 'thumbs-up',
                }
          }
        >
          {reactionType ? REACTIONS[reactionType].text : getText('Like')}
        </Button>
      </CmsReactionButtonContainer>
    </Tooltip>
  );
}
